import { MUITab } from "@abb/arcadia-ui-react"
import { useHashTab } from "../../../hooks/useHashTab"
import { KeyValuePairs } from "./deprecated_devices_tab/DeprecatedDevices"

const DEPRECATED_DEVICES_TAB_ID = "deprecated-devices"

export function DeprecatedDevicesContainer() {
  const { activeTab, handleTabChange } = useHashTab(DEPRECATED_DEVICES_TAB_ID)

  return (
    <div>
      <MUITab
        tabItems={[{ id: DEPRECATED_DEVICES_TAB_ID, label: "Deprecated Devices" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === DEPRECATED_DEVICES_TAB_ID && <KeyValuePairs />}
    </div>
  )
}
